




























































































































	import {Prop, Watch} from "vue-property-decorator";
	import {Stored} from 'vue-stored-prop-decorator';
	import {Component, Vue} from '@/shared/component';
	import {Timeout, WatchObjectProperties} from '@/shared/decorator';

	import {storeLivraisonsTotaux, LivraisonFilter} from '@/stores/modules/livraison';

	import InputDateFilter from '@/components/Input/DateFilter.vue';
	import CrudTransporteurSearch from "@/components/Crud/Transporteur/Search.vue";
	import InputBoisType from "@/components/Input/BoisType.vue";
	import {DateFilterMode} from "@/shared/filter";

	@Component({
		components: {
			InputDateFilter,
			InputBoisType,
			CrudTransporteurSearch,
		}
	})
	export default class CrudLivraisonFilterTotauxLivraisons extends Vue {

		@Prop({ type: Boolean, default: false}) reduce!: boolean;

		@Stored(() => storeLivraisonsTotaux) private page!: number;
		@Stored(() => storeLivraisonsTotaux) private filters!: LivraisonFilter;

		@WatchObjectProperties('filters', LivraisonFilter)
		@Timeout()
		private filtersWatcher(): void {
			this.page = 0;
			storeLivraisonsTotaux.dispatch( 'getTotauxLivraisons', { filters: true });
		}
		
		public mounted() {
		    this.typeWatcher();
			var dt = new Date();
			dt.setDate(dt.getDate() - 90);
			this.filters.totalDateDebut = dt.toISOString().substr(0, 10)
			this.filters.totalDateFin = (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)
		}

	    @Watch('type')
		private typeWatcher(): void {
            this.filters.clear();

		}

		private get methodName(): string {
			return 'getTotauxLivraisons';
		}

		@Watch('order')
		@Watch('page')
		@Watch('direction')
		private refresh(): void {
			storeLivraisonsTotaux.dispatch(this.methodName, { filters: true });
		}

		private menu = false;
		private menuEnd = false;
	}
